import { collection, addDoc, serverTimestamp } from "firebase/firestore";

import { db } from "../../firebase/firebase";

const projectsCollection = collection(db, "projects");

const addProject = async (projectData) => {
  try {
    console.log("Saving project to Firestore...");

    const finalProjectData = {
      ...projectData,
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp(),
    };

    const docRef = await addDoc(projectsCollection, finalProjectData);

    console.log("Project saved successfully:", docRef.id);

    return {
      id: docRef.id,
      ...finalProjectData,
    };
  } catch (error) {
    console.error("ADD PROJECT ERROR:", error);

    throw error;
  }
};

export { addProject };
